import {
    ChainSelector,
    ComposeSelector,
    ContextWithQuery,
    ContextWithTranslatedQuery,
    ExtractSuggestionsPipeline,
    FallbackSelector,
    FixedSelector,
    HasLastSelected,
    KeywordSelector
} from "@me8eon/agent";
import {LlmPipelineDetails} from "@me8eon/llm_agents";
import {LlmSelector, TranslateSelector} from "@me8eon/llm_selector";
import {AppendTextToMessagePipeline} from "@me8eon/agent/src/pipelines/appendTextToMessagePipeline";


export type Context = ContextWithQuery & HasLastSelected & ContextWithTranslatedQuery

export type Pipelines =
    | LlmPipelineDetails
    | ExtractSuggestionsPipeline
    | AppendTextToMessagePipeline


export type SimpleSelector =
    | FixedSelector
    | LlmSelector
    | KeywordSelector
    | TranslateSelector


export type Selector = SimpleSelector
    | ChainSelector<SimpleSelector>
    | FallbackSelector<SimpleSelector>
    | ComposeSelector<SimpleSelector>;

